import type { Op } from 'quill/core';

const deltaOnlyContainWhitespace = (ops: Op[]) =>
  ops.every(({ insert }) => typeof insert === 'string' && !insert.trim());

export default deltaOnlyContainWhitespace;
